/**-----------------------------------------------------------------------------
 *                                    E2RH
 * -----------------------------------------------------------------------------
 *
 *  filename: index.js
 *
 *  author: Thomas CLERET (thomas.cleret@proton.me)
 *
 *  creation: 16/9/2025 - 16:24
 *
 *  description:
 *
 *  Copyright (c) 2025 E2RH
 * -----------------------------------------------------------------------------
 */

import { ToastContainer, Bounce } from 'react-toastify';
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { StyledEngineProvider } from '@mui/material/styles';
import "./styles.css";
import "./tailwindcss.css";

import App from "./App.tsx";

ReactDOM.createRoot(document.getElementById("root")).render(<React.StrictMode>
   <StyledEngineProvider injectFirst>
      <ToastContainer
         position="top-left"
         autoClose={5000}
         limit={10}
         hideProgressBar={false}
         newestOnTop
         closeOnClick
         rtl={false}
         pauseOnFocusLoss
         draggable
         pauseOnHover
         theme="light"
         transition={Bounce}
      />
      <App />
   </StyledEngineProvider>
</React.StrictMode>);
